import { render, staticRenderFns } from "./RecommendationList.vue?vue&type=template&id=41a57355&scoped=true&"
import script from "./RecommendationList.vue?vue&type=script&lang=js&"
export * from "./RecommendationList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendationList.vue?vue&type=style&index=0&id=41a57355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/ronaspergel/Projects/otjs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a57355",
  null
  
)

export default component.exports